export type RenderFailureInput = {
  incidentId: string;
  error: unknown;
  componentStack?: string | undefined;
  occurredAt?: Date | undefined;
  write?: ((serializedEvent: string) => void) | undefined;
};

type RenderFailureEvent = {
  schemaVersion: 1;
  event: 'ui_render_failed';
  incidentId: string;
  occurredAt: string;
  boundary: 'application_root';
  errorName: string;
  component: string;
};

const COMPONENT_NAME = /\bat\s+([A-Za-z_$][\w.$-]*)/;

export function createIncidentId(): string {
  return crypto.randomUUID();
}

function componentNameFrom(stack: string | undefined): string {
  return stack?.match(COMPONENT_NAME)?.[1] ?? 'unknown';
}

/**
 * Emits only allow-listed operational fields. Error messages and raw stacks
 * are deliberately excluded because either can contain account or grow data.
 */
export function reportRenderFailure({
  incidentId,
  error,
  componentStack,
  occurredAt = new Date(),
  write = console.error,
}: RenderFailureInput): void {
  const event: RenderFailureEvent = {
    schemaVersion: 1,
    event: 'ui_render_failed',
    incidentId,
    occurredAt: occurredAt.toISOString(),
    boundary: 'application_root',
    errorName: error instanceof Error ? error.name : 'NonErrorThrow',
    component: componentNameFrom(componentStack),
  };

  write(JSON.stringify(event));
}
